<template>
<transition name="slide-fade">
    <div class="dialog-view" v-show="visible">        
        <div class="record-modal u-window">           
            <div class="dialog-content">              
                <div class="u-btn close" @click="destroyElement"></div>
                <div class="dialog-wrapper">
                    <div class="dialog-title t-record"></div>
                    <div class="record-view">
                        <ul>
                            <li v-for="(item,index) in list" :key="item.orderId">
                                <span>{{ (now-1) * parseInt(perpage) + index + 1 }}</span>
                                <span>{{ item.giftName }}</span>
                                <span>{{ item.sendTime }}</span>
                            </li>
                        </ul>                    
                    </div>

                    <div class="u-pager" v-if="allpages > 1">
                        <span v-for="n in allpages" :key="n" :class="n==now ? 'act': ''" @click="setpage(n)">{{ n }}</span>
                    </div>    

                    <div class="u-btn ok" @click="destroyElement"></div>
                </div>
            </div>
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
export default {
    data : function () {
        return {
            visible : false,
            list : [],
            allpages : 0,
            now : 1,
            perpage : 5,          
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    methods: {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        setpage(n){
            var _this = this;
            this.$axios.get(_this.$global.ajax_url_map.draw_record,{
                params : {
                    pageindex : n,
                    pagesize: _this.perpage,
                    source : 2,
                }
            })
            .then(res => {
                if(res.data.code == 0){
                    //success
                    _this.list = res.data.data.list;
                    _this.allpages = Math.min(res.data.data.allPages,10);
                    _this.now = n;
                }
                else{
                    _this.$toast(res.data.message);
                }
            });            
        },        
    }    
}
</script>

<style scoped>

    .record-modal{
        width: 510px;
        padding-top: 25px;
        padding-bottom: 40px;
        background-color: #ded4be;
    }

    .t-record{
        width: 157px;
        height: 37px;
        margin: 0 auto 20px;
        background-image: url(../../images/title-record.png);
    }



    .record-view{
        margin: 0 52px;
        border: 1px solid #ab957e;
        border-bottom: none;
    }

    .record-view li{
        display: flex;
        justify-content: space-between;
        line-height: 42px;
        padding: 0 30px;
        font-size: 14px;
        color: #63544b;
        border-bottom: 1px solid #ab957e;
    }

    .u-pager{
        width: 100%;
        font-size: 18px;
        margin-top: 10px;
        color: #63544b;
        text-align: center;
    }

    .u-pager span{
        padding: 0 10px;
        cursor: pointer;
    }

    .u-pager span.act{
        color: #b18b27;
    }    

    .u-btn.ok{
        width: 166px;
        height: 49px;
        margin: 15px auto 0;
        background-image: url(../../images/btn-ok.png);    
    }
    
    .u-btn.ok:hover{
        background-image: url(../../images/btn-ok_hover.png);   
    }
@media screen and (min-device-width: 1025px){
    .record-modal .u-btn.close{
        top: 0;
    }
}
    
@media screen and (max-device-width: 1024px){
    .record-modal{
        width: 609px;       
    }

    .record-view li{
        font-size: 24px;
    }

    .u-pager{
        font-size: 24px;
    }
}    
</style>


// WEBPACK FOOTER //
// src/components/RecordModal/RecordModal.vue